'use client'

import {
  SiCloudflare,
  SiCss,
  SiDrizzle,
  SiGit,
  SiHtml5,
  SiJavascript,
  SiMysql,
  SiPostgresql,
  SiPython,
  SiReact,
  SiReactquery,
  // yeni eklenen backend / tooling ikonları
  SiOpenjdk,            // java yerine OpenJDK (Simple Icons'da Java resmi bazen kaldırılmıştır)
  SiSpringboot,
  SiDjango,
  SiPostman,
  SiGithub,
  SiMongodb,
  SiRedis,
  SiPhp,
  SiGnubash,            // bash / GNU bash ikonu (pakette farklı isim varsa simpleicons.org'dan kontrol et)
  SiUbuntu,
  SiRabbitmq,
  SiDocker
} from '@icons-pack/react-simple-icons'
import { useTranslations } from '@tszhong0411/i18n/client'
import { Marquee } from '@tszhong0411/ui/components/marquee'
import { ZapIcon } from 'lucide-react'

const StacksCard = () => {
  const t = useTranslations()

  return (
    <div className='shadow-feature-card flex h-60 flex-col gap-2 overflow-hidden rounded-xl p-4 lg:p-6'>
      <div className='flex items-center gap-2'>
        <ZapIcon className='size-[18px]' />
        <h2 className='text-sm'>{t('homepage.about-me.stacks')}</h2>
      </div>

      <Marquee gap='20px' className='py-4' fade pauseOnHover>
        <SiHtml5 className='size-10' />
        <SiCss className='size-10' />
        <SiJavascript className='size-10' />
        <SiReact className='size-10' />
        <SiPython className='size-10' />
        <SiOpenjdk className='size-10' />
        <SiSpringboot className='size-10' />
        <SiDjango className='size-10' />
        <SiPostman className='size-10' />
        <SiGithub className='size-10' />
      </Marquee>

      <Marquee gap='20px' className='py-4' reverse fade pauseOnHover>
        <SiPostgresql className='size-10' />
        <SiMongodb className='size-10' />
        <SiMysql className='size-10' />
        <SiRedis className='size-10' />
        <SiDocker className='size-10' />
        <SiRabbitmq className='size-10' />
        <SiGit className='size-10' />
        <SiGnubash className='size-10' />
        <SiUbuntu className='size-10' />
        <SiCloudflare className='size-10' />
        <SiDrizzle className='size-10' />
        <SiReactquery className='size-10' />
        <SiPhp className='size-10' />
      </Marquee>
    </div>
  )
}

export default StacksCard
